import classNames from 'classnames';
import React from 'react';

interface ListItemSkeletonProps {
 wrapperClassName?: string;
 className?: string;
}

export const ListItemSkeleton: React.FC<ListItemSkeletonProps> = ({wrapperClassName,className}) => {
  return (
    <div className={classNames('flex justify-center relative top-[18px]', wrapperClassName)}>
      <div className={classNames('empty-page-loader',className)} />
    </div>
  );
};
